
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class WebsiteOrderProductsGrid extends Serenity.EntityGrid<WebsiteOrderProductsRow, any> {
        protected getColumnsKey() { return WebsiteOrderProductsColumns.columnsKey; }
        protected getDialogType() { return WebsiteOrderProductsDialog; }
        protected getIdProperty() { return WebsiteOrderProductsRow.idProperty; }
        protected getInsertPermission() { return WebsiteOrderProductsRow.insertPermission; }
        protected getLocalTextPrefix() { return WebsiteOrderProductsRow.localTextPrefix; }
        protected getService() { return WebsiteOrderProductsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}